(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["s7-wishlist"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('s7-wishlist')) {
    const key = '6and7:wishlist:v1';
    let products = [];
    let storageAvailable = true;
    const read = () => {
      if (!storageAvailable) return products;
      try {
        const saved = JSON.parse(localStorage.getItem(key) || '[]');
        if (!Array.isArray(saved)) return [];
        return saved.filter((item) => {
          if (!item || !/^\d+$/.test(item.id) || typeof item.title !== 'string' || typeof item.url !== 'string') return false;
          try {
            const url = new URL(item.url, location.origin);
            return url.origin === location.origin && url.pathname.includes('/products/');
          } catch { return false; }
        }).filter((item, index, all) => all.findIndex((other) => other.id === item.id) === index);
      } catch { storageAvailable = false; return products; }
    };
    products = read();
    const notify = () => document.dispatchEvent(new CustomEvent('s7:wishlist-change'));
    const save = () => {
      try { localStorage.setItem(key, JSON.stringify(products)); storageAvailable = true; }
      catch { storageAvailable = false; }
      notify();
    };
    const announce = (message) => {
      const widget = document.querySelector('s7-wishlist');
      if (!widget) return;
      const target = widget.querySelector(widget.querySelector('dialog').open ? '[data-wishlist-dialog-status]' : '[data-wishlist-status]');
      target.textContent = '';
      requestAnimationFrame(() => { target.textContent = message; });
    };
    class WishlistToggle extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        if (!this.button) return;
        this.addEventListener('click', this.toggle);
        document.addEventListener('s7:wishlist-change', this.update);
        this.update();
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.toggle);
        document.removeEventListener('s7:wishlist-change', this.update);
      }
      update = () => {
        const selected = products.some((item) => item.id === this.dataset.id);
        this.button.setAttribute('aria-pressed', String(selected));
        this.button.setAttribute('aria-label', selected ? this.dataset.removeLabel : this.dataset.addLabel);
        const label = this.querySelector('[data-wishlist-label]');
        if (label) label.textContent = selected ? this.dataset.savedText : this.dataset.saveText;
      };
      toggle = (event) => {
        event.preventDefault();
        event.stopPropagation();
        products = read();
        const selected = products.some((item) => item.id === this.dataset.id);
        if (selected) products = products.filter((item) => item.id !== this.dataset.id);
        else products.unshift({ id: this.dataset.id, title: this.dataset.title, vendor: this.dataset.vendor, url: this.dataset.url, image: this.dataset.image || '' });
        save();
        const widget = document.querySelector('s7-wishlist');
        if (widget) announce(storageAvailable ? widget.dataset[selected ? 'removed' : 'added'] : widget.dataset.storageError);
      };
    }
    class Wishlist extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.list = this.querySelector('[data-wishlist-list]');
        document.addEventListener('click', this.handleClick);
        document.addEventListener('s7:wishlist-change', this.update);
        this.dialog.addEventListener('close', this.onClose);
        this.dialog.addEventListener('click', this.onBackdrop);
        this.update();
      }
      disconnectedCallback() {
        document.removeEventListener('click', this.handleClick);
        document.removeEventListener('s7:wishlist-change', this.update);
        this.dialog.removeEventListener('close', this.onClose);
        this.dialog.removeEventListener('click', this.onBackdrop);
      }
      handleClick = (event) => {
        const open = event.target.closest('[data-wishlist-open]');
        if (open) {
          event.preventDefault();
          this.opener = open;
          products = read();
          notify();
          this.renderList();
          this.dialog.showModal();
          document.querySelectorAll('[data-wishlist-open]').forEach((button) => button.setAttribute('aria-expanded', 'true'));
        }
        if (event.target.closest('[data-wishlist-close]') && this.contains(event.target)) this.dialog.close();
        const remove = event.target.closest('[data-wishlist-remove]');
        if (remove && this.contains(remove)) {
          const index = Array.from(this.list.children).indexOf(remove.closest('li'));
          products = read().filter((item) => item.id !== remove.dataset.wishlistRemove);
          save();
          const buttons = this.list.querySelectorAll('[data-wishlist-remove]');
          (buttons[Math.min(index, buttons.length - 1)] || this.querySelector('[data-wishlist-close]')).focus();
          announce(storageAvailable ? this.dataset.removed : this.dataset.storageError);
        }
      };
      onBackdrop = (event) => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
      };
      onClose = () => {
        document.querySelectorAll('[data-wishlist-open]').forEach((button) => button.setAttribute('aria-expanded', 'false'));
        if (this.opener?.isConnected) this.opener.focus();
      };
      update = () => {
        document.querySelectorAll('[data-wishlist-count]').forEach((count) => { count.textContent = String(products.length); count.hidden = products.length === 0; });
        if (this.dialog.open) this.renderList();
      };
      renderList() {
        const fragment = document.createDocumentFragment();
        for (const product of products) {
          const item = document.createElement('li');
          item.className = 's7-wishlist-item';
          const media = document.createElement('a');
          media.className = 's7-wishlist-item-image';
          media.href = product.url;
          media.tabIndex = -1;
          media.setAttribute('aria-hidden', 'true');
          if (product.image) {
            try {
              const src = new URL(product.image, location.origin);
              if (src.protocol === 'https:' && (src.origin === location.origin || src.hostname === 'cdn.shopify.com')) {
                const img = document.createElement('img');
                img.src = src.href;
                img.alt = '';
                img.width = 84;
                img.height = 106;
                img.loading = 'lazy';
                media.append(img);
              }
            } catch {}
          }
          const details = document.createElement('a');
          details.className = 's7-wishlist-item-details';
          details.href = product.url;
          const vendor = document.createElement('span');
          vendor.className = 's7-wishlist-item-vendor';
          vendor.dir = 'auto';
          vendor.textContent = product.vendor || '';
          const title = document.createElement('span');
          title.className = 's7-wishlist-item-title';
          title.dir = 'auto';
          title.textContent = product.title;
          details.append(vendor, title);
          const remove = document.createElement('button');
          remove.type = 'button';
          remove.className = 's7-wishlist-remove';
          remove.dataset.wishlistRemove = product.id;
          remove.textContent = this.dataset.removeLabel;
          remove.setAttribute('aria-label', this.dataset.removeLabel + ': ' + product.title);
          item.append(media, details, remove);
          fragment.append(item);
        }
        this.list.replaceChildren(fragment);
        this.querySelector('[data-wishlist-empty]').hidden = products.length > 0;
      }
    }
    customElements.define('s7-wishlist-toggle', WishlistToggle);
    customElements.define('s7-wishlist', Wishlist);
    window.addEventListener('storage', (event) => { if (event.key === key || event.key === null) { products = read(); notify(); } });
    window.addEventListener('pageshow', () => { products = read(); notify(); });
  }
  } catch(e) { console.error(e); }
})();

})();
